import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样式
import {
  Message
} from 'element-ui'
import {
  getToken
} from '@/utils/auth' // 验权

const whiteList = ['/login'] // 不重定向白名单
router.beforeEach(async (to, from, next) => {
  NProgress.start()
  let token = localStorage.getItem('token')
  if (token) {
    if (to.path === '/login') {
      next({
        path: '/'
      })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.roles.length === 0) {
        await store.dispatch('GetAgentConfig')
        console.log('configconfig', store.getters.config)
        store.dispatch('GetInfo').then(res => { // 拉取用户信息
          console.log(res);
          let permissionsArr = []
          res.menus.forEach(item => {
            if (store.getters.config && store.getters.config.money_name && item.name ==
              'homemember_money_log') {
              //余额
              let title = store.getters.config.money_name.value ? store.getters.config.money_name.value :
                '余额'
              item.title = `${title}日志`
            }
            if (store.getters.config && store.getters.config.point_title && item.name ==
              'homemember_point_log') {
              // 积分
              let title = store.getters.config.point_title.value ? store.getters.config.point_title
                .value : '积分'
              item.title = `${title}日志`
            }
            if (store.getters.config && store.getters.config.contribution_name && item.name ==
              'homemember_amount_log') {
              item.title = `${store.getters.config.contribution_name.value}日志`
            }

            permissionsArr.push(item.name)
          })
          localStorage.setItem('PermissionsArr', permissionsArr)
          // console.log('permissionsArr',permissionsArr);
          let menus = res;
          let username = res.admin.username;
          store.dispatch('GenerateRoutes', {
            menus,
            username
          }).then(() => { // 生成可访问的路由表
            // console.log(store.getters.addRouters);
            router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
            next({
              ...to,
              replace: true
            })
          })
        }).catch((err) => {
          console.log(err);
          store.dispatch('FedLogOut').then(() => {
            Message.error(err || 'Verification failed, please login again')
            next({
              path: '/'
            })
          })
        })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})


// WEBPACK FOOTER //
// ./src/permission.js